export const fetchGetSchedule = () =>
  fetch(`/api/v1/admin/schedule`).then((res) => res.json())

export const fetchGetWorkingSchedule = () => fetch(`/api/v1/schedule`).then((res) => res.json())
